import { lazyLoadComponentFactory } from "@Components/Modules/Helpers";

export type { ILocationModal } from "./LocationModal";
export default lazyLoadComponentFactory(
    () => import(/* webpackChunkName: "location-modal" */ "./LocationModal"),
);
